import discoverTodoServiceModel from './discoverTodoServiceModel';

export default async function getTodoApiRequestUrl(relativeUrlFragment: string): Promise<string> {
    const model = await discoverTodoServiceModel();
    if (model === 'todob2') {
        // Modern B2 service must be called directly (relying on CAFE routing)
        // since not all servers will have the service installed
        return '/todob2/api/v1' + relativeUrlFragment;
    } else {
        // Legacy B service can be called through OWS' proxy (bypassing CAFE routing)
        // since it is guaranteed to be installed on each server
        return '/ows/todo/api/v1' + relativeUrlFragment;
    }
}
